import { render, staticRenderFns } from "./tracker-employee-by-sex.vue?vue&type=template&id=2e20f296&scoped=true&"
import script from "./tracker-employee-by-sex.vue?vue&type=script&lang=js&"
export * from "./tracker-employee-by-sex.vue?vue&type=script&lang=js&"
import style0 from "./tracker-employee-by-sex.vue?vue&type=style&index=0&id=2e20f296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20f296",
  null
  
)

export default component.exports